module.exports = __webpack_public_path__ + "public/img/icon_shujufenxi.4e8b0109.png";